// @flow
import RadioSelect from 'fg-frontend/src/components/RadioSelect';
import UniversalPaginationButton from 'fg-frontend/components/UniversalPaginationButton';
// COMMON: Komponenta zajistuje deaktivaci odkazu po prvnim kliknuti
import PreventDoubleClickHandler from 'fg-frontend/src/components/PreventDoubleClickHandler';

import {RangeSlider} from 'fg-frontend/src/components/RangeSlider';
import AddSvgIconSprite from './components/AddSvgIconSprite';
import GtmHandler from './components/GtmHandler';
// COMMON: Komponenta, ktera umoznuje posilat data do systemu Targito (odeberte, pokud Targito feature nepouzivate)
import TargitoHandler from './components/TargitoHandler';
import TriggerInViewport from './components/TriggerInViewport';
import HeaderBadge from './components/HeaderBadge';
//import SubmenuToggle from './components/SubmenuToggle';
import SimpleCollapse from './components/SimpleCollapse';
// Megamenu
import Megamenu from './components/Megamenu';

import configureEshopComponents from './configureEshopComponents';

export default (props) => {
	switch (props.decorator || props.is) {
		case 'AddSvgIconSprite':
			return AddSvgIconSprite;
		case 'RadioSelect':
		case 'CheckboxSelect':
			return RadioSelect;
		case 'HeaderBadge':
			return HeaderBadge;
		case 'SimpleCollapse':
			return SimpleCollapse;
    case 'PreventDoubleClickHandler':
      return PreventDoubleClickHandler;
    case 'ArticlesSlider':
      return import('./components/ArticlesSlider');
    case 'UspList':
      return import('./components/UspList');
		case 'Typeahead':
			return import('fg-frontend/components/Typeahead');
		case 'SelectDesign':
			return import('./components/SelectDesign');
		case 'ListToggle':
			return import('fg-frontend/components/ListToggle');
		case 'PasswordToggle':
			return import('fg-frontend/components/PasswordToggle');
		case 'SocialShare':
			return import('fg-frontend/components/SocialShare');
		case 'Webslider':
			return import('./components/Webslider');
		case 'AnchorsList':
			return import('./components/AnchorsList');
		case 'RangeSlider':
			return RangeSlider;
		case 'RadioSelectTab':
			return import('fg-frontend/src/components/RadioSelectTab');
    case 'AlertBox':
      // COMMON: Komponenta pro osetreni informacnich boxu (odeberte, pokud nepouzivate funkcionalitu/extenzi AlertBox)
      return import('./components/AlertBox');
		case 'NumberInput':
			return import('fg-frontend/components/NumberInput');
		case 'UniversalPaginationButton':
			return UniversalPaginationButton;
		case 'Tooltip':
			return import('./components/Tooltip');
		case 'PhotoSwipe':
			return import('./components/PhotoSwipe');
		case 'GtmHandler':
			return GtmHandler;
    case 'TargitoHandler':
      return TargitoHandler;
		case 'TriggerInViewport':
			return TriggerInViewport;
		case 'RedirectToUrl':
			return import('fg-frontend/src/components/RedirectToUrl');
		case 'GoogleRecaptcha':
			return import('fg-frontend/src/components/GoogleRecaptcha');
		case 'Form':
		  return import('fg-frontend/src/components/Form');
		case 'Countdown':
		  return import('./components/Countdown');
		case 'ShowMore':
			return import('./components/ShowMore');
    case 'UspSlider':
      return import('./components/UspSlider');
    case 'VariantZoom':
      return import('./components/VariantZoom');
    case 'Tabs':
      return import('./components/Tabs');
    case 'Megamenu':
      return Megamenu;
		default:
			const eshopComponent = configureEshopComponents(props);
			if (eshopComponent) {
				return eshopComponent;
			}
			else {
				console.log(`Unknown component ${props.decorator || props.is}`);
				return null;
			}
	}
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWebComponents.js